import {AbilityBuilder, Ability, AbilityClass} from '@casl/ability';
import authModule from '@/store/modules/authModule';

/*
  Общий тип действий для разрешений
*/
type Actions = 'view';

/*
  Тип разрешений сервисов
*/
type ServiceObjects =
  | 'coolant_service'
  | 'monitor_errors_service'
  | 'workload_service'
  | 'diagnostic_assistance_service'
  | 'vibration_diagnostics_service';

/*
  Тип разрешений журналов
*/
type JournalObjects =
  | 'nodes_journal'
  | 'modules_journal'
  | 'sensors_journal'
  | 'hardware_journal'
  | 'measurements_journal'
  | 'users_journal'
  | 'roles_journal'
  | 'broker_logs_journal';

/*
  Общий тип разрешений
*/
type Objects =
  | 'services'
  | 'system'
  | 'administration'
  | 'developer_module_info'
  | ServiceObjects
  | JournalObjects;

/*
  Интерфейс для разрешений
*/
export interface UserPermission {
  obj: Objects;
  action: Actions;
}

/*
  Интерфейс составных разрешений
*/
export interface CompoundPermission {
  obj: Objects;
  depentent: Objects[];
}

/*
  Список составных разрешений
  */

export const compoundPermissions: CompoundPermission[] = [
  {
    obj: 'services',
    depentent: [
      'coolant_service',
      'monitor_errors_service',
      'workload_service',
      'diagnostic_assistance_service',
      'vibration_diagnostics_service',
      'sensors_journal',
    ],
  },
  {obj: 'administration', depentent: ['users_journal', 'roles_journal', 'broker_logs_journal']},
  {
    obj: 'system',
    depentent: [
      'nodes_journal',
      'hardware_journal',
      'modules_journal',
      'sensors_journal',
      'measurements_journal',
    ],
  },
];

/*
  Настройка разрешений для CASL
*/
export type AppAbility = Ability<[Actions, Objects]>;
export const AppAbility = Ability as AbilityClass<AppAbility>;

export function defineRulesFor(permissions: UserPermission[]) {
  const {can, rules} = new AbilityBuilder(AppAbility);

  //добавляем составные разрешения
  compoundPermissions
    .filter(p => p.depentent.filter((x: string) => permissions.some(y => y.obj == x)).length)
    .forEach(p => can('view', p.obj));

  //добавляем разрешения
  permissions.forEach(p => can(p.action, p.obj));
  return rules;
}

export function getAppAbility() {
  return new AppAbility(defineRulesFor(authModule.getPermissions));
}

export function updateAppAbility(component: any) {
  component.$ability.update(defineRulesFor(authModule.getPermissions));
}
